export { Building as default } from './Building';
